import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card } from 'react-bootstrap';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

import ListingReportsVendor from 'components/ListingReportsVendor';
import MasterPage from 'components/MasterPage';
import { api } from 'services';
import { DashboardOutlined } from '@material-ui/icons';
import ExportTable from 'components/ExportTable';

const ReportVendor = () => {
  const defaultFilters = { __search: '', per_page: 10, page: 1 };
  const [filters, setFilters] = useState(defaultFilters);
  const [reports, setReports] = useState({ data: [], pagination: {} });
  const { t } = useTranslation();

  useEffect(() => {
    api
      .get('report-index', { params: { ...filters } })
      .then(({ data }) => {
        setReports(data)
      });
  }, [filters]);

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Card.Body className="shadow bg-white rounded mb-3">
        <Row>
          <Col className="d-flex mt-3 mb-3">
            <DashboardOutlined className="icon-title" />
            <h4 className="title-dashboard mt-2">{t('title:vendor report')}</h4>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            <Row>
              <Col>
                <ExportTable
                  buttonText={t('label:export')}
                  fileName="Report Vendor"
                  data={async (filters) => {
                    let filters_aux = { ...filters };
                    let _r = await (api.get('report-index', { params: { ...filters_aux } }));
                    return _r;
                  }}
                  filters={filters}
                  table={(reports) => {
                    return (
                      <ListingReportsVendor
                        exportData={reports}
                      />
                    );
                  }}
                />
              </Col>
            </Row>
            <Row className="mt-5">
              <Col>
                <ListingReportsVendor
                  reports={reports}
                  filters={[]}
                  stateFilters={filters}
                  setFilters={setFilters}
                  handleFilterChange={handleFilterChange}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </>
  );
};

export default MasterPage(ReportVendor);
